<template>
  <div class="goods">
    <v-head style="position: fixed;width: 100%;z-index:20" :title="title"></v-head>
    <div class="signup" id="content" v-wechat-title="$route.meta.title">
      <div class="bannerSignup">
        <img :src="url" alt class />
        <img v-if="!url" src="../../assets/images/bmBg.jpg" />
      </div>
      <div class="inputBox">
        <van-button block round color="linear-gradient(to right, #1cd65a, #00cc74)" @click="go('signupSearch')">
          查看报名状态
        </van-button>
        <p class="fontSizeDiv">如果已报名，点击按钮即可查看报名状态</p>
        <div class="inputCont">
          <ul>
            <li :class="{ 'active s1': type === '1' }" @click="type = '1'">
              在线报名
            </li>
            <li :class="{ 'active s2': type === '2' }" @click="type = '2'">
              报名须知
            </li>
          </ul>
          <div style="background-color: #f3f3f3;padding-bottom: 1.7rem;" v-show="type == '1'">
            <div v-show="!showFlase">
              <div class="inputkuang">
                <p class="fontSizeDiv">
                  <i><van-icon name="warning-o" /></i>注：带
                  <span style="color:red">*</span> 的所填项为必填项
                </p>
                <personAdvancedForm style="padding-top: 0;padding-bottom: 0;" :ruleForm.sync="formData"
                  :unitDetail="settingDetail" :loginStatus="loginStatus" ref="personValidate" @setUserInfo="setUserInfo"
                  :infoDisabled="infoDisabled" :isMemberAct="meetingDetail.isMemberAct?meetingDetail.isMemberAct:1">
                </personAdvancedForm>
              </div>


              <!-- 发票 -->
              <div class="group_29 flex-col invoicelist " v-if="meetingDetail.duesType==2">
                <div class=" flex-col inputkuang2">
                  <div class="group_2">
                    <span class=" text_8">发票</span>
                  </div>
                  <div class="group_12">
                    <dl>
                      <dt>
                        发票信息 <sup>*</sup>
                      </dt>
                      <dd>
                        <van-field v-model="invoiceInfo" is-link readonly name="invoiceInfo" placeholder="点击填写发票信息"
                          @click="addinvoice()" />
                      </dd>
                    </dl>

                  </div>
                </div>
                <div></div>
                <van-popup class="invoice" v-model="showBottom" closeable :close-on-click-overlay="false"
                  position="bottom">
                  <van-form @submit="admitInvoice" ref="admitInvoice">
                    <div style="margin-top: 1.5rem ;padding-bottom: 0; " class=" flex-col group_1 group_29">
                      <div class="group_1 flex-col">
                        <div class="group_2 " style="padding-left: 0;padding-right: 0;">
                          <p class="text_2">发票详情</p>
                          <div class=" text-wrapper_2 flex-col">
                            <van-field name="radio" required :rules="[{ required: true, message: '请选择抬头类型' }]"
                              label="抬头类型">
                              <template #input>
                                <van-radio-group v-model="invoiceParams.type" @change="changeInvoiceType"
                                  direction="horizontal" style="margin-left: 0;">
                                  <van-radio :name="2">单位 </van-radio>
                                  <van-radio :name="1">个人</van-radio>
                                </van-radio-group>
                              </template>
                            </van-field>
                            <van-field required v-model="invoiceParams.invoiceCompanyName" label="发票抬头"
                              placeholder="请输入发票抬头" :rules="[{ required: true, message: '请输入发票抬头' }]" maxlength="64" />
                            <van-field required v-model="invoiceParams.invoiceEmail" label="收票邮箱" placeholder="请输入邮箱"
                              :rules="[{ required: true, message: '请输入邮箱' }]" maxlength="64" />
                            <van-field @blur="checkTin" maxlength="20" v-if="invoiceParams.type == 2" required
                              v-model="invoiceParams.tin" label="纳税人识别号" placeholder="请输入纳税人识别号" :rules="[
                        { required: true, message: '请输入纳税人识别号' },
                      ]" />
                            <van-field disabled v-if="invoiceParams.type == 2" v-model="invoiceParams.info" label="更多内容"
                              placeholder="填写注册地址、电话等（非必填）" @click="show = true" class="more" />
                          </div>
                        </div>
                      </div>
                      <van-dialog class="moredialog" v-model="show" confirmButtonText="保存" @confirm="saveNorequired">
                        <div class="box_2 flex-row justify-between" style="margin-left: 2.7rem;">
                          <span class="text_22">更多内容</span>
                          <van-icon name="cross" class="icon_1" @click="show = false" />
                        </div>
                        <!-- abc -->
                        <div class="block_1 flex-col ">
                          <van-field label-class="label-justify" v-model="invoiceParams.invoiceBank" label="开户银行"
                            maxlength="100" placeholder="选填">
                          </van-field>
                          <van-field label-class="label-justify" id="valueInput" v-Alphabet maxlength="100"
                            v-model="invoiceParams.invoiceAccount" label="银行账号" placeholder="选填" />
                          <van-field label-class="label-justify" v-model="invoiceParams.invoiceAddress" label="单位地址"
                            maxlength="100" placeholder="选填" />
                          <van-field label-class="label-justify" id="gudtel" v-gudtel maxlength="30"
                            v-model="invoiceParams.invoiceTelephone" label="电话号码" placeholder="选填" />
                          <van-field label-class="label-justify" maxlength="65" type="textarea" autosize
                            v-model="invoiceParams.invoiceRemarks" label="备注" placeholder="选填" />
                        </div>
                        <div class="box-1 flex-row "
                          style="margin: 0 0 10px;display: flex;justify-content: center;width: 100%;">
                          <button class="button-5 flex-col" @click.prevent="saveNorequired">
                            <span class="text_37">保存</span>
                          </button>
                        </div>
                      </van-dialog>
                    </div>
                    <div class="group_1 group_29 flex-col " style="padding-top: 0;">
                      <div class=" group_2 flex-col " style="padding: 6px;">
                        <p class="text_2" style="margin-bottom: 0.3rem;">取票方式</p>
                        <div class=" text-wrapper_2 flex-col ">
                          <van-notice-bar left-icon="info-o">请在收票邮箱中查看发票</van-notice-bar>

                        </div>
                        <div class=" text-wrapper_2 flex-col justify-between" v-if="invoiceParams.invoiceType == 1">
                          <div>
                            <van-radio-group v-model="invoiceParams.deliveryType" direction="horizontal">
                              <van-radio name="1">邮寄</van-radio>
                              <van-radio name="2">现场取票</van-radio>
                            </van-radio-group>
                            <div v-if="invoiceParams.deliveryType == 1" class=" text-wrapper_2 flex-col ">
                              <van-field required v-model="invoiceParams.deliveryContact" label="收件人"
                                placeholder="请输入收件人" :rules="[{ required: true, message: '请输入收件人' }]" />
                              <van-field required v-model="invoiceParams.deliveryMobile" label="手机号"
                                placeholder="请输入手机号" :rules="[{ required: true, message: '请输入手机号' }]" />
                              <van-field required v-model="invoiceParams.deliveryDetailedAddress" label="邮寄地址"
                                placeholder="填写邮寄地址" :rules="[{ required: true, message: '填写邮寄地址' }]" />
                            </div>
                            <van-notice-bar left-icon="info-o">抵达会议现场，您可通过提供联系人方式或单位名称向工作人员索要发票.</van-notice-bar>
                          </div>
                        </div>
                      </div>
                      <button class="button-1 flex-col" style="margin-left: 0;width: 100%;" @click="admitInvoice()">
                        <span class="text_14">确认提交</span>
                      </button>
                    </div>
                  </van-form>
                </van-popup>
              </div>
              <!-- 酒店 -->

              <div class="group_29 flex-col  " v-if="meetingDetail.isHotel==1">
                <div class=" flex-col inputkuang2">
                  <div class="group_2">
                    <span class=" text_8">
                      酒店住宿
                      <span v-if="inCheckTime==1" style="color: red;">(未开始)</span>
                      <span v-if="inCheckTime==2" style="color: red;">(已截止)</span>
                    </span>
                  </div>
                  <div class="group_12">
                    <dl>
                      <dt>是否需要住宿 <sup>*</sup></dt>
                      <dd>
                        <van-field name="accommodationFlag" class="input-item" :rules="[{
                          required: true,
                          message: '请选择是否需要住宿',
                        }]">
                          <template #input>
                            <van-radio-group v-model="hotelParams.accommodationFlag" direction="horizontal"
                              :disabled="inCheckTime==1||inCheckTime==2">
                              <van-radio :key="2" :name="2">是</van-radio>
                              <van-radio :key="1" :name="1">否</van-radio>
                            </van-radio-group>
                          </template>
                        </van-field>
                      </dd>
                    </dl>
                    <van-form ref="admithotel">
                      <div v-if="hotelParams.accommodationFlag==2">
                        <dl>
                          <dt>请选择酒店/宾馆 <sup>*</sup></dt>
                          <dd>
                            <van-field v-model="hotelInfo" is-link readonly name="hotelInfo" placeholder="点击选择酒店/宾馆"
                              :rules="[{ required: true, message: '请选择酒店/宾馆' }]" @click="addhetol()" />
                          </dd>
                        </dl>
                        <dl v-if="hotelInfo">
                          <dt>房型 <sup>*</sup></dt>
                          <dd>
                            <van-field class="input-item" name="roomType" :rules="[{
                            required: true,
                            message: '请选择房型',
                          }]">
                              <template #input>
                                <van-radio-group v-model="hotelParams.roomType" direction="horizontal">
                                  <van-radio :key="1" :name="1"
                                    :disabled="!checkHotel.leftSingle">单间(剩余{{checkHotel.leftSingle?checkHotel.leftSingle:0}}间)</van-radio>
                                  <van-radio :key="2" :name="2"
                                    :disabled="!checkHotel.leftStandard">标间(剩余{{checkHotel.leftStandard?checkHotel.leftStandard:0}}间)</van-radio>
                                </van-radio-group>
                              </template>
                            </van-field>
                          </dd>
                        </dl>
                        <dl>
                          <dt>入住人性别 <sup>*</sup></dt>
                          <dd>
                            <van-field class="input-item" name="guestGender" :rules="[{
                            required: true,
                            message: '请选择入住人性别',
                          }]">
                              <template #input>
                                <van-radio-group v-model="hotelParams.guestGender" direction="horizontal">
                                  <van-radio :key="1" :name="1">男</van-radio>
                                  <van-radio :key="2" :name="2">女</van-radio>
                                </van-radio-group>
                              </template>
                            </van-field>
                          </dd>
                        </dl>
                        <dl>
                          <dt>入住人姓名 <sup>*</sup></dt>
                          <dd>
                            <van-field v-model="hotelParams.guestName" name="guestName" placeholder="请输入入住人姓名"
                              maxlength="64" clearable :rules="[{ required: true, message: '请输入入住人姓名' }]" />
                          </dd>
                        </dl>
                        <dl>
                          <dt>住宿时间 <sup>*</sup></dt>
                          <dd>
                            <van-field name="checkrangeTime" class="justify-between time" @click="showcalendar1 = true"
                              v-model="checkrangeTime" placeholder="请选择住宿时间" is-link @focus="noBomBox" :rules="[
                            {
                              required: true,
                              message: '请选择住宿时间',
                            },
                          ]">
                            </van-field>
                          </dd>
                        </dl>
                        <van-calendar type="range" v-model="showcalendar1" @confirm="onConfirm1" :default-date="null"
                          :minDate="new Date()" :formatter="formatter" />
                        <!-- <dl>
                          <dt>退房时间 <sup>*</sup></dt>
                          <dd>
                            <van-field name="singleOut" class="justify-between time" @click="showcalendar2 = true"
                              v-model="hotelParams.checkOutTime" placeholder="请选择预计退房时间" is-link @focus="noBomBox"
                              :rules="[
                            {
                              required: true,
                              message: '请选择预计退房时间',
                            },
                          ]">
                            </van-field>
                          </dd>
                        </dl> -->
                        <!-- <van-calendar v-model="showcalendar2" @confirm="onConfirm2" /> -->
                      </div>
                    </van-form>
                  </div>
                </div>
                <van-popup v-model="showHotel" :close-on-click-overlay="false" position="bottom" class="hotel"
                  :style="{maxHeight:'50%'}">
                  <div class="group_29a">
                    <div class="closeicon">
                      <span @click="resetHotel">重置</span>
                      <span @click="closeHotel">确认</span>
                    </div>
                    <div class=" flex-col group_1 " style="margin-top: 1.45rem;">
                      <div class="group_1 flex-col ">
                        <div style="padding-left: 0;padding-right: 0;">
                          <van-radio-group v-model="hotelParams.hotelId" shape="dot" @change="changeHotel">
                            <template v-for="item in meetingHotelDTOs">
                              <van-radio :key="item.id" :name="item.id">
                                <div>
                                  <h4 style="margin-bottom: 0.27rem;font-family: PingFangSC-regular;font-weight:600">
                                    {{item.name}}</h4>
                                  <div class="hotelbox">
                                    <van-icon class="icon_6 " name="hotel-o" />
                                    <span class="hoteltitle">标间</span>
                                    <span class="hoteldetail">剩余:{{item.leftStandard?item.leftStandard:0}}间</span>
                                    <span class="hoteldetails" v-if="item.dipositStandard">价格:
                                      <span style="color: red;">￥{{item.dipositStandard.toFixed(2)}}</span>
                                    </span>
                                  </div>
                                  <div class="hotelbox">
                                    <van-icon class="icon_6" name="hotel-o" />
                                    <span class="hoteltitle">单间</span>
                                    <span class="hoteldetail">剩余:{{item.leftSingle?item.leftSingle:0}}间</span>
                                    <span class="hoteldetails" v-if="item.dipositSingle">价格:
                                      <span style="color: red;">￥{{item.dipositSingle.toFixed(2)}}</span>
                                    </span>
                                  </div>
                                </div>
                              </van-radio>
                            </template>
                          </van-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>


                </van-popup>

              </div>

              <!-- 分会场 -->
              <div class="group_29 flex-col " v-if="meetingDetail.isPlace==1">
                <div class=" flex-col inputkuang2">
                  <div class="group_2">
                    <span class=" text_8">分会场</span>
                  </div>
                  <div class="group_12">
                    <van-form ref="admitPlace">
                      <dl>
                        <dt>请选择分会场<sup v-if="meetingDetail.canMeetingPlaceMandatory==2">*</sup></dt>
                        <dd>
                          <van-field v-model="placeInfo" readonly is-link name="placeInfo" placeholder="点击选择分会场"
                            @click="addplace()" />
                        </dd>
                      </dl>
                    </van-form>
                  </div>
                </div>
                <van-popup v-model="showPlace" closeable :close-on-click-overlay="false" position="bottom"
                  :style="{ maxHeight: '50%' }" class="hotel">
                  <div class="group_29a">
                    <div class="closeicon">
                      <span @click="resetplace">重置</span>
                      <span @click="closeplace">确认</span>
                    </div>

                    <div class=" flex-col group_1 " style="margin-top: 1.45rem;">
                      <div class="group_1 flex-col ">
                        <div style="padding-left: 0;padding-right: 0;">
                          <van-radio-group v-model="checked" shape="dot" v-if="meetingDetail.meetingPlaceRule==2"
                            @change="changePlace">
                            <template v-for="item in meetingPlaceDTOs">
                              <van-radio :key="item.id" :name="item.id" :disabled="!item.leftNum">
                                <div>
                                  <h4>{{item.name}}(剩余{{item.leftNum}}名)</h4>
                                </div>
                              </van-radio>
                            </template>
                          </van-radio-group>
                          <van-checkbox-group v-model="checkedlist" shape="dot" v-else @change="changePlace">
                            <template v-for="item in meetingPlaceDTOs">
                              <van-checkbox :key="item.id" :name="item.id" :disabled="!item.leftNum">
                                <div>
                                  <h4>{{item.name}}(剩余{{item.leftNum}}名)</h4>
                                </div>
                              </van-checkbox>
                            </template>
                          </van-checkbox-group>
                        </div>
                      </div>
                    </div>
                  </div>

                </van-popup>

              </div>
            </div>
            <div class="buttonDiv">
              <div>
                <van-button v-if="inRegisterTime==1" :disabled="submitdisabled" color="#bebebe" block
                  @click="submit()">暂未开始报名</van-button>
                <van-button v-else-if="inRegisterTime==2" :disabled="submitdisabled" color="#bebebe" block
                  @click="submit()">已截止报名</van-button>
                <van-button v-else :disabled="submitdisabled" type="primary" block @click="submit()">提交报名信息</van-button>
              </div>

            </div>
          </div>

          <div class="notice" v-show="type == '2'">
            <dl>
              <dt>活动名称：</dt>
              <dd>{{ meetingDetail.name }}</dd>
            </dl>

            <dl>
              <dt>报名时间：</dt>
              <dd>
                {{ formatDateYMD(meetingDetail.registerStartDate) }} 至
                {{ formatDateYMD(meetingDetail.registerEndDate) }}
              </dd>
            </dl>
            <div v-for="item  in meetingContentDTOs" :key="item.id">
              <h4 style="color:#686868;width: 100%;text-align: center;">{{item.title}}</h4>
              <div class="mapBox">
                <div class="intrCont" v-html="item.content"></div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import {
    getMeetingSettings,
    signeGroupRegister,
    getMeetingDetail,
    getPZUrl,
    getDictionary,
    meetingRegisterDetails
  } from "@/api/dictionary";
  import Vue from "vue"

  import {
    getSessionStore,
    setSessionStore,
  } from "../../utils/sessionStorage.js";
  import { mapGetters, mapState, mapActions } from "vuex";
  import Sidentify from "../../components/VerificationCode"; //**引入验证码组件**
  import personAdvancedForm from "@/views/MeetingCenter/companySignUp/advancedForm"
  import vHead from "@/components/Subhead.vue";
  import {
    Row,
    Col,
    Swipe,
    SwipeItem,
    DatetimePicker,
    Form,
    Icon,
    Field,
    Button,
    Toast,
    Tabs,
    Tab,
    Dialog,
    Radio,
    NavBar,
    Popup,
    Area,
    Cell,
    Checkbox,
    Divider,
    CheckboxGroup,
    Collapse,
    CollapseItem,
    RadioGroup,
    NoticeBar,
    Stepper,
    Calendar,
    Picker,
  } from "vant";
  Vue.directive("Alphabet", {
    inserted: function (el) {
      const input = el.querySelector("#valueInput")
      input.onkeyup = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
      input.onblur = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
    },
  })
  Vue.directive("gudtel", {
    inserted: function (el) {
      const input = el.querySelector("#gudtel")
      input.onkeyup = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
      input.onblur = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
    },
  })
  Vue.directive("telphone", {
    inserted: function (el) {
      const input = el.querySelector("#telphone")
      input.onkeyup = function (e) {
        input.value = input.value.replace(/[^1[3|4|5|8][0-9]\d{4,8}$]/g, "")
      }
      input.onblur = function (e) {
        input.value = input.value.replace(/[^1[3|4|5|8][0-9]\d{4,8}$]/g, "")
      }
    },
  })


  export default {
    data() {
      return {
        title: '在线报名',
        type: "1",
        settingDetail: [],
        formData: {
          name: '',
          mobile: '',
          code: ''
        },
        userInfo: {},
        meetingContentDTOs: [],
        tipContent: "",
        infoDisabled: false,
        showFlase: false,
        code: null,
        url: "",
        minDate: null,
        // meetingId: null,
        meetingDetail: {},
        meetingAffairDetail: {},
        identifyCode: "",
        identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
        allDictionary: [],
        pickerField: undefined, // 弹窗选择对应的字段
        dateField: undefined, // 弹窗日期选择的字段,
        selectModel: false,
        columns: [],
        key: "name", //选择弹窗显示对应的参数名,
        loginStatus: false, //默认未登录
        // 发票数据
        show: false,
        checked: "",
        checkedlist: [],
        username: "",
        telephone: "",
        address: "",
        invoiceInfo: null,
        invoiceParams: {
          checkedGetType1: "", //取票方式
          checkedGetType2: "", //取票方式
          type: 2,
          username: "",
          invoiceRemarks: "",
          invoiceCompanyName: "",
          invoiceEmail: '',
          tin: "",
          telephone: "",
          email: "",
          mobile: "",
          info: "已填写0项",
          invoiceType: 2,
          deliveryType: 3,
          deliveryContact: "",
          deliveryMobile: "",
        },
        // 酒店
        dialogHotel: false,
        showHotel: false,
        hotelInfo: '',
        meetingHotelDTOs: [],
        checkrangeTime: '',
        inCheckTime: '',//1代表还未开始，2代表已截止
        inRegisterTime: '',
        hotelParams: {
          accommodationFlag: 2,
          meetingPlaceIds: '',
          guestGender: '',
          guestName: '',
          checkInTime: '',
          checkOutTime: '',
          hotelId: '',
          roomType: ''
        },
        checkHotel: {},
        showcalendar1: false,
        showcalendar2: false,
        singleStatus: false, //单间是否需校验
        showBottom: false,
        hotelStartDate: '',
        hotelEndDate: '',
        // 分会场
        meetingPlaceDTOs: [],
        showPlace: false,
        placeInfo: '',
        submitdisabled: false,
      };
    },
    components: {
      personAdvancedForm,
      vHead,
      [Row.name]: Row,
      [Col.name]: Col,
      [SwipeItem.name]: SwipeItem,
      [Swipe.name]: Swipe,
      "v-sidentify": Sidentify,
      [DatetimePicker.name]: DatetimePicker,
      [Dialog.Component.name]: Dialog.Component,
      [NavBar.name]: NavBar,
      [NoticeBar.name]: NoticeBar,
      [Icon.name]: Icon,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Form.name]: Form,
      [Radio.name]: Radio,
      [Cell.name]: Cell,
      [Field.name]: Field,
      [Button.name]: Button,
      [Stepper.name]: Stepper,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      [Toast.name]: Toast,
      [Popup.name]: Popup,
      [Divider.name]: Divider,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Area.name]: Area,
      [RadioGroup.name]: RadioGroup,
      [Picker.name]: Picker,
      [Calendar.name]: Calendar,
    },
    methods: {
      ...mapActions(["securityCheck"]),
      getData() {
        getMeetingSettings({ meetingId: this.meetingId })
          .then((resp) => {
            if (resp.success) {
              this.settingDetail = resp.result;
              this.settingDetail.forEach(field => {
                if (field.editorType == 2) {
                  this.$set(field, "fileList", [])
                  this.$set(this.formData, field.field, [])

                }
                // 如果有默认选中
                if (field.meetingDictionaryList) {
                  field.meetingDictionaryList.map(item => {
                    if (item.isDefault == 1) {
                      // console.log('2', item.value, item, field.field, item.seq)
                      if (field.editorType == 14) {
                        this.$set(this.formData, field.field, [item.value])
                      } else {
                        if (!this.formData[field.field]) {
                          this.$set(this.formData, field.field, item.value);
                        }
                      }

                    }
                  })
                }
              })
            }
          })
          .catch(() => {
            Toast.fail("获取报名设置失败！");
          });
        getMeetingDetail({ meetingId: this.meetingId }).then((res) => {
          if (res.success) {
            let status = res.result.meetingDTO.status
            if (!status || status != 1) {
              this.$confirm('该会议未审核通过暂无法报名', "提示", {
                type: "warning",
                showClose: false,
                // showConfirmButton: false,
                showCancelButton: false
              }).then(() => {
                // this.$router.push('login')
                this.$router.push({ name: "MeetingList" });
              }).catch(() => {
                // this.$router.push('login')
                this.$router.push({ name: "MeetingList" });
              });
            }

            this.meetingDetail = res.result.meetingDTO;
            this.meetingHotelDTOs = res.result.meetingHotelDTOs
            // 将字符串转换为Date对象 
            if (res.result.meetingDTO.hotelStartDate) {
              var hotelStartDate = new Date(res.result.meetingDTO.hotelStartDate);
              var hotelEndDate = new Date(res.result.meetingDTO.hotelEndDate);
              // 获取当前日期和时间  
              var currentDate = new Date();
              // 确保当前日期在开始日期和结束日期之间（包括开始和结束日期）  
              if (currentDate >= hotelStartDate && currentDate <= hotelEndDate) {
                this.inCheckTime = ''
                this.hotelParams.accommodationFlag = 2
              } else if (currentDate < hotelStartDate) {
                this.inCheckTime = 1
                this.hotelParams.accommodationFlag = 1
              } else if (currentDate > hotelEndDate) {
                this.inCheckTime = 2
                this.hotelParams.accommodationFlag = 1
              }
            }
            // 会议是否截止或未开始
            if (res.result.meetingDTO.registerStartDate) {
              var registerStartDate = new Date(res.result.meetingDTO.registerStartDate);
              var registerEndDate = new Date(res.result.meetingDTO.registerEndDate);
              // 获取当前日期和时间  
              var currentDate = new Date();
              // 确保当前日期在开始日期和结束日期之间（包括开始和结束日期）  
              if (currentDate >= registerStartDate && currentDate <= registerEndDate) {
                this.inRegisterTime = ''
                this.submitdisabled = false
              } else if (currentDate < registerStartDate) {
                this.inRegisterTime = 1
                this.submitdisabled = true
              } else if (currentDate > registerEndDate) {
                this.inRegisterTime = 2
                this.submitdisabled = true
              }
            }
            this.$route.meta.title = res.result.meetingDTO.name;
            this.meetingPlaceDTOs = res.result.meetingPlaceDTOs
            this.meetingContentDTOs = res.result.meetingContentDTOs
            // 酒店可选择入住期间
            this.hotelStartDate = new Date(res.result.meetingDTO.hotelStartDate)
            this.hotelEndDate = new Date(res.result.meetingDTO.hotelEndDate)
            document.title = res.result.meetingDTO.name
            if (this.reRegister) {
              this.getdatadetail()
            }
            if (res.result.meetingDTO.photoId) {
              this.getPZUrl();
            }
          }
        });
      },
      go(path) {
        let memberId = sessionStorage.getItem("memberId")
        if (this.loginStatus || memberId) {
          this.$router.push({ name: 'SignUpmeetingCenter', })
        } else {
          this.$router.push({ name: path, query: { meetingId: this.meetingId, } });
        }
      },
      getPZUrl() {
        let params = {
          id: this.meetingDetail.photoId,
        };
        getPZUrl(params).then((res) => {
          this.url = res.result;
        });
      },
      submit() {
        //验证表单必填内容
        let valid = this.$refs["personValidate"].validateForm()
        if (!valid) {
          return
        }
        if (this.formData.mobile) {
          if (!this.$regexp.mobile(this.formData.mobile)) {
            Toast(`请输入正确的手机号码`)
            return
          }
        }
        if (this.formData.email) {
          if (!this.$regexp.email(this.formData.email)) {
            Toast(`请输入正确的邮箱地址`)
            return
          }
        }
        if (this.invoiceParams.invoiceEmail) {
          if (!this.$regexp.email(this.invoiceParams.invoiceEmail)) {
            Toast(`请输入正确的发票邮箱地址`)
            return
          }
        }
        if (!this.formData.messageCode && !this.loginStatus) {
          Toast("验证码不能为空");
          return;
        }
        if (!this.$refs.personValidate.codeStatus && !this.loginStatus) {
          Toast("验证码不正确");
          return;
        }

        // 校验发票信息
        if (this.meetingDetail.duesType != 1) {
          if (this.invoiceParams.type == 1 && (!this.invoiceParams.invoiceCompanyName || !this.invoiceParams.invoiceEmail)) {
            Toast.fail("发票信息不能为空!")
            return
          }
          if (this.invoiceParams.type == 2 && (!this.invoiceParams.invoiceCompanyName || !this.invoiceParams.tin || !this.invoiceParams.invoiceEmail)) {
            Toast.fail("发票信息不能为空!")
            return
          }
        }
        // 校验分会场信息
        if (this.meetingDetail.canMeetingPlaceMandatory == 2) {
          if (this.meetingDetail.meetingPlaceRule == 2 && !this.checked) {
            Toast.fail("请选择分会场!")
            return
          } else if (this.meetingDetail.meetingPlaceRule == 1 && !this.checkedlist[0]) {
            Toast.fail("请选择分会场!")
            return
          }
        }
        if (this.meetingDetail.isHotel == 1 && this.hotelParams.accommodationFlag == 2) {
          // 校验酒店预订信息
          this.$refs["admithotel"].validate().then(() => {
            this.save()
          })
        } else {
          //无酒店 
          this.hotelParams.accommodationFlag = 1
          this.save()
        }
      },
      save() {
        this.submitdisabled = true
        this.formData.meetingId = this.meetingId;
        let params = {
          ...this.formData,
          ...this.hotelParams,
          invoiceTin: this.invoiceParams.tin,
          invoiceTitleType: this.invoiceParams.type,
          invoiceCompanyName: this.invoiceParams.invoiceCompanyName,
          invoiceType: this.invoiceParams.invoiceType,
          invoiceBank: this.invoiceParams.invoiceBank,
          invoiceAccount: this.invoiceParams.invoiceAccount,
          invoiceTelephone: this.invoiceParams.invoiceTelephone,
          invoiceRemarks: this.invoiceParams.invoiceRemarks,
          invoiceAddress: this.invoiceParams.invoiceAddress,
          invoiceEmail: this.invoiceParams.invoiceEmail
        }
        this.settingDetail.forEach(item => {
          if (item.editorType == 14 || item.editorType == 2) {
            params[item.field] = this.formData[item.field].join(',')
          }
        })
        if (this.meetingDetail.isPlace == 1) {
          if (this.meetingDetail.meetingPlaceRule == 2) {
            params.meetingPlaceIds = this.checked
          } else {
            params.meetingPlaceIds = this.checkedlist.join(',')
          }
        }
        signeGroupRegister(params).then((res) => {
          this.tipContent = "";
          if (res.success) {
            if (this.meetingDetail.duesType == 1) { //免费会议
              this.$router.push({
                name: "SignUpmeetingCenter",
              })
            } else {
              sessionStorage.setItem("Paypage", JSON.stringify(res.result))
              this.$router.push({
                name: "Paypage",
                query: {
                  orderId: res.result.orderInfo.id,
                  amount: res.result.orderInfo.amount,
                  orderNo: res.result.orderInfo.orderNo,
                  sourceName: "signup",
                },
              })
            }
            this.submitdisabled = false
          } else {
            this.submitdisabled = false
            Toast.fail(res.message);
          }
        });
      },
      showDatePicker(pickerField, dateField) {
        this.pickerField = pickerField;
        this.dateField = dateField;
        this.selectModel = true;
      },
      onConfirmDate(time) {
        this.dateField.value = time;
        //this.formData[this.dateField.field] = time;
        this.formData[this.dateField.field] = this.dateFormatString(time);
        this.selectModel = false;
      },
      dateFormatString(value, item) {
        if (!value) {
          return
        }
        let date = new Date(value);
        let m = date.getMonth() + 1;
        let d = date.getDate();
        if (m >= 1 && m <= 9) {
          m = "0" + m;
        }
        if (d >= 0 && d <= 9) {
          d = "0" + d;
        }
        return date.getFullYear() + "-" + m + "-" + d;
      },
      // 重置验证码
      refreshCode() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
      },
      makeCode(o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
          ];
        }
      },
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },


      formatDateYMD(timeStamp) {
        if (timeStamp) {
          let year = new Date(timeStamp).getFullYear();
          let month =
            new Date(timeStamp).getMonth() + 1 < 10
              ? "0" + (new Date(timeStamp).getMonth() + 1)
              : new Date(timeStamp).getMonth() + 1;
          let date =
            new Date(timeStamp).getDate() < 10
              ? "0" + new Date(timeStamp).getDate()
              : new Date(timeStamp).getDate();
          let hh =
            new Date(timeStamp).getHours() < 10
              ? "0" + new Date(timeStamp).getHours()
              : new Date(timeStamp).getHours();
          let mm =
            new Date(timeStamp).getMinutes() < 10
              ? "0" + new Date(timeStamp).getMinutes()
              : new Date(timeStamp).getMinutes();
          let ss =
            new Date(timeStamp).getSeconds() < 10
              ? "0" + new Date(timeStamp).getSeconds()
              : new Date(timeStamp).getSeconds();
          return year + "-" + month + "-" + date;
        } else {
          return "暂无时间";
        }
      },
      getDisplayValue(value, field) {
        var optionsData = this.fieldDictionary(field.dictionaryId);
        var currentItem = optionsData.find((item) => item.value === value);
        return currentItem ? currentItem.name : "";
      },
      showPicker(pickerField, dateField) {
        this.pickerField = pickerField;
        this.columns = this.fieldDictionary(pickerField.dictionaryId);
        this.selectModel = true;
      },
      onCancel() {
        this.selectModel = false;
      },

      onConfirm(item) {
        this.selectModel = false;
        var fieldVal;
        this.formData[this.pickerField.field] = fieldVal = item.value;
        this.pickerField.value = fieldVal;
        this.pickerField.displayValue = item.name;
        this.pickerField = undefined;
        this.selectKey = undefined;
      },
      onChange(picker, values, index) {
        if (this.selectKey === "title") {
          picker.setColumnValues(1, values[0].children);
        } else if (this.selectKey === "jg" || this.selectKey === "province") {
          let city = this.allAddress.filter((item) => {
            return item.parentId === values[0].id;
          });
          if (index === 0) {
            picker.setColumnValues(1, city);
          }
        }
      },

      // 纳税人识别号校验
      checkTin() {
        if (!/^[0-9a-zA-Z]{1,20}$/.test(this.invoiceParams.tin)) {
          Toast.fail("请输入正确的纳税人识别号！")
          return false
        }
      },
      // 打开发票
      addinvoice() {
        this.showBottom = true
      },
      // 保存选填
      saveNorequired() {
        let num = 0
        if (this.invoiceParams.invoiceBank) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceAccount) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceAddress) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceTelephone) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceRemarks) {
          num = num + 1
        }
        // let str = this.invoiceParams.invoiceRemarks
        // let count = str.length
        // console.log("111", count) // 输出：13
        this.invoiceParams.info = "已填写" + num + "项"
        this.show = false
      },
      // 提交开票信息
      admitInvoice() {
        if (!this.$regexp.email(this.invoiceParams.invoiceEmail)) {
          Toast.fail(`请输入正确的邮箱地址`)
          return false
        }
        if (this.invoiceParams.type == 2) {
          if (!/^[0-9a-zA-Z]{1,20}$/.test(this.invoiceParams.tin)) {
            Toast.fail("请输入正确的纳税人识别号！")
            return false
          }
        }

        this.$refs.admitInvoice
          .validate()
          .then(() => {
            //成功时的程序
            console.log(this.invoiceParams)
            this.invoiceInfo = this.invoiceParams.invoiceCompanyName
            this.showBottom = false
          })
          .catch(() => {
            //失败时的程序
            // Toast.fail(err)
          })
      },
      //改变发票类型
      changeInvoiceType(value) {
        if (value == 2) {
          // this.invoiceParams.invoiceCompanyName = this.formData.name
          // this.invoiceParams.tin = this.formData.code
        } else {
          // this.invoiceParams.invoiceCompanyName = this.formData.name
          this.invoiceParams.tin = ""
        }
      },
      // 是否預訂酒店
      formatter(day) {
        if (day.type === 'start') {
          day.bottomInfo = '入住';
        } else if (day.type === 'end') {
          day.bottomInfo = '离店';
        }

        return day;
      },
      radioHotel(val) {
        if (val == 2) {
          this.showHotel = true;
        } else {
          this.showHotel = false;
        }
      },
      addhetol() {
        this.showHotel = true
      },
      changeHotel(val) {
        let item = this.meetingHotelDTOs.filter(item => item.id == val)
        this.checkHotel = item[0]
        this.hotelParams.roomType = ''
      },
      resetHotel() {
        this.hotelParams.hotelId = ''
        this.hotelInfo = ''
      },
      closeHotel() {
        let item = this.meetingHotelDTOs.filter(item => item.id == this.hotelParams.hotelId)
        let arr = []
        if (item[0]) {
          arr.push(item[0].name)
          this.hotelInfo = arr.join(',')
        }
        this.showHotel = false
      },
      noBomBox() {
        document.activeElement.blur()
      },
      // 订房时间
      formatDate(date) {
        date = new Date(date)
        return `${date.getFullYear()}-${this.format(
          date.getMonth() + 1
        )}-${this.format(date.getDate())}`
      },
      // 订房时间
      formatDatevalue(date) {
        date = new Date(date)
        return `${date.getFullYear()}-${this.format(
          date.getMonth() + 1
        )}-${this.format(date.getDate())}`
      },
      format(n) {
        return n < 10 ? "0" + n : "" + n
      },
      onConfirm1(values) {
        const [start, end] = values;
        this.checkrangeTime = `${this.formatDatevalue(start)} - ${this.formatDatevalue(end)}`;
        this.hotelParams.checkInTime = this.formatDatevalue(start)
        this.hotelParams.checkOutTime = this.formatDatevalue(end)
        this.showcalendar1 = false
        // if (this.hotelParams.checkOutTime) {
        //   let end = new Date(this.hotelParams.checkOutTime)
        //   let start = new Date(this.formatDate(value))
        //   if (start.getTime() > end.getTime()) {
        //     Toast("入住时间要早于退房时间")
        //     return
        //   }
        // }

      },
      onConfirm2(value) {
        this.showcalendar2 = false
        if (this.hotelParams.checkInTime) {
          let start = new Date(this.hotelParams.checkInTime)
          let end = new Date(this.formatDate(value))
          if (start.getTime() > end.getTime()) {
            Toast("退房时间要晚于入住时间")
            return
          }
        }
        this.hotelParams.checkOutTime = this.formatDate(value)
      },
      addplace() {
        this.showPlace = true
      },
      resetplace() {
        this.checked = '';
        this.checkedlist = [];
        this.placeInfo = ''
      },
      closeplace() {
        this.showPlace = false
      },
      changePlace(val) {
        let arr = []
        let item = []
        if (this.meetingDetail.meetingPlaceRule == 2) {
          item = this.meetingPlaceDTOs.filter(item => item.id == val)
          if (item[0]) {
            arr.push(item[0].name)
          }
          this.placeInfo = arr.join(',')
        } else {
          val.forEach(id => {
            item = this.meetingPlaceDTOs.filter(item => item.id == id)
            if (item[0]) {
              arr.push(item[0].name)
            }
          })
          this.placeInfo = arr.join(',')
        }
      },
      getUserInfo() {
        return new Promise((resolve) => {
          getUser().then((res) => {
            if (res.success) {
              this.userInfo = res.result
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.result)
              )
              sessionStorage.setItem("memberId", res.result.id)
              this.memberId = res.result.id
              resolve()
            } else {
              Toast.fail("用户信息获取失败")
            }
          })
        })
      },
      setUserInfo(val) {
        if (val == 'checkCode') {
          this.infoDisabled = true
        }
        let info = localStorage.getItem("userInfo")
        console.log('val', val)
        if (info) {
          this.userInfo = JSON.parse(info)
          if (!this.userInfo.name) {
            this.$refs.personValidate.isnameDisabled(false)
          } else {
            this.$refs.personValidate.isnameDisabled(true)
          }
          this.formData.mobile = this.userInfo.mobile ? this.userInfo.mobile : ''
          this.formData.code = this.userInfo.code
          if (!this.formData.name) {
            this.formData.name = this.userInfo.name ? this.userInfo.name : ''
          }
        }
      },
      // 重新报名时获取报名数据
      getdatadetail() {
        meetingRegisterDetails({
          id: this.meetingRegisterId,
        }).then((res) => {
          this.formData = res.result.meetingRegister
          delete this.formData.expiryDate;
          delete this.formData.id;
          delete this.formData.registerTime;
          this.invoiceInfo = res.result.meetingRegister.invoiceCompanyName
          this.invoiceParams = {
            tin: res.result.invoiceTin,
            type: res.result.invoiceTitleType,
            invoiceCompanyName: res.result.invoiceCompanyName,
            invoiceType: res.result.invoiceType,
            invoiceBank: res.result.invoiceBank,
            invoiceAccount: res.result.invoiceAccount,
            invoiceTelephone: res.result.invoiceTelephone,
            invoiceRemarks: res.result.invoiceRemarks,
            invoiceAddress: res.result.invoiceAddress,
            invoiceEmail: res.result.invoiceEmail
          }
          this.saveNorequired()
          console.log(this.meetingHotelDTOs)
          let item = this.meetingHotelDTOs.filter(item => item.id == res.result.meetingRegister.hotelId)
          let arr = []
          if (item[0]) {
            arr.push(item[0].name)
            this.hotelInfo = arr.join(',')
          }
          this.changeHotel(res.result.meetingRegister.hotelId)
          this.hotelParams.accommodationFlag = res.result.meetingRegister.accommodationFlag
          if (res.result.meetingRegister.accommodationFlag == 2) {
            this.hotelParams.meetingPlaceIds = res.result.meetingRegister.meetingPlaceIds,
              this.hotelParams.guestGender = res.result.meetingRegister.guestGender,
              this.hotelParams.guestName = res.result.meetingRegister.guestName,
              this.hotelParams.checkInTime = res.result.meetingRegister.checkInTime ? res.result.meetingRegister.checkInTime.substr(0, 10) : '',
              this.hotelParams.checkOutTime = res.result.meetingRegister.checkOutTime ? res.result.meetingRegister.checkOutTime.substr(0, 10) : '',
              this.hotelParams.hotelId = res.result.meetingRegister.hotelId,
              this.hotelParams.roomType = res.result.meetingRegister.roomType
            //  回显酒店选择区间
            this.checkrangeTime = res.result.meetingRegister.checkInTime.substr(0, 10)
              + "-" + res.result.meetingRegister.checkOutTime.substr(0, 10)
          }
          //  回显文件
          this.settingDetail.forEach(item => {
            if (item.editorType == 2) {
              let label = item.field
              let namlist = this.formData[label] ? this.formData[label].split(',') : []
              namlist.forEach(item2 => {
                const parts = item2.split('/');
                // 移除数组的第一个元素（即第一个'/'之前的部分）  
                parts.shift();
                // 将剩余的部分重新组合成一个字符串  
                const result = parts.join('/');
                item.fileList.push({ url: '', name: result })

              })
            }
            if (item.editorType == 14 || item.editorType == 2) {
              this.formData[item.field] = this.formData[item.field].split(',')
            }
            if (item.editorType == 13) {
              this.formData[item.field] = this.formData[item.field].substr(0, 10)
            }
          })
          // 分会场单选
          if (res.result.meetingPlaceIds) {
            if (this.meetingDetail.meetingPlaceRule == 2) {
              this.checked = res.result.meetingPlaceIds
              this.changePlace(this.checked)
            } else {
              this.checkedlist = res.result.meetingPlaceIds.split(',')
              this.changePlace(this.checkedlist)
            }
          }


        })
      }
    },
    computed: {
      meetingId() {
        return this.$route.query && this.$route.query.meetingId;
      },
      reRegister() {
        return this.$route.query && this.$route.query.reRegister;
      },
      meetingRegisterId() {
        return this.$route.query && this.$route.query.meetingRegisterId;
      },
      hyType() {
        return this.$route.query && this.$route.query.type;
      }
    },
    created() {
      let token = sessionStorage.getItem("access_token")
      if (!token) {
        sessionStorage.clear()
        localStorage.clear()
      }
    },
    mounted() {

      this.setUserInfo() //设置用户信息回显
      this.loginStatus = Boolean(this.$route.query && this.$route.query.loginStatus)
      if (this.loginStatus) {
        this.infoDisabled = true
      }
      let memberId = sessionStorage.getItem("memberId")
      this.getData();
      // 初始化验证码
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
      getDictionary().then((res) => {
        if (res.success) {
          this.allDictionary = res.result;
        }
      });
      this.minDate = new Date("1960-01-01");
    },
  };
</script>
<style scoped lang="less">
  .page {
    position: relative;
    overflow: hidden;
    font-size: 0.48rem !important;
  }

  .group_1 {
    background-color: rgba(245, 245, 247, 1);
    padding-bottom: 10px;
  }

  /deep/.el-popper {
    background: #fff !important;
    width: 104% !important;
    padding-left: 5%;
    /* height: 150px !important; */
  }

  /deep/.van-field__value {
    width: 76%
  }

  /deep/.van-cell__value {
    width: 76%;
    text-align: left;
  }

  /deep/.el-scrollbar__wrap {
    max-height: 150px;
    overflow: scroll;
  }

  /deep/.van-cell__right-icon {
    position: absolute;
    right: 15px;
  }

  /deep/input::-webkit-input-placeholder {
    color: #ccc;
  }

  /deep/.van-checkbox__icon .van-icon {
    width: 18px;
    height: 18px;
  }

  /deep/.label-justify {
    text-align-last: justify;
    padding-right: 17px;
  }

  .image_1 {
    width: 361px;
    height: 17px;
    margin: 0 16px 0 37px;
  }

  /deep/.van-field__control {
    /* width: auto; */
  }

  /* 
  /deep/.van-radio-group--horizontal {
    margin-left: 16px;
  } */

  /* /deep/.van-checkbox-group--horizontal {
    margin-left: 16px;
  } */

  /deep/.van-field--error .van-field__control::placeholder {
    color: #ccc;
  }

  /deep/.van-popup {
    overflow-x: hidden;
  }

  /deep/.van-field__control--right {
    text-align: left;
  }

  /deep/ .van-field__label,
  /deep/.van-cell__title {
    width: 160px !important;
    color: #000;
    padding-left: 5px;
  }

  /deep/.van-cell--required .van-cell__title::after {
    position: static;
    color: transparent;
    font-size: 0.37333rem;
    content: "\A0*";
  }

  .hotel /deep/.van-radio {
    background-color: #fff;
    align-items: start !important;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 5px;
  }

  .hotel /deep/.van-checkbox {
    background-color: #fff;
    align-items: start !important;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 5px;
  }

  .hotel /deep/.van-cell--required::before {
    position: static;
  }

  .hotel .hotelbox {
    width: 330px;
    background-color: #fff;
    padding: 10px 0;
    display: flex;
  }

  .hotel .hotelbox .tips {
    width: 6px;
    height: 17px;
    line-height: 20px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
  }

  .hotel .hotelbox .hoteltitle {
    display: inline-block;
    margin-right: 15px;
    width: 40px;
  }

  .hotel .hotelbox .hoteldetail {
    display: inline-block;
    width: 37%;
  }

  .hotel .hotelbox .hoteldetails {
    display: inline-block;
    width: 44%;
  }

  .hotel .hotelbox p {
    height: 25px;
  }

  .holetinfo {
    padding: 0 16px 0 16px;
  }

  /deep/.van-divider {
    margin: 0;
  }

  .text-wrapper_2 {
    background-color: rgba(255, 255, 255, 1);
  }

  /deep/.van-collapse-item__title {
    background-color: rgba(230, 230, 232, 0.56);
  }

  /deep/.van-collapse-item {
    margin-bottom: 2px;
  }

  /deep/.van-cell::after {
    border-color: transparent !important;
    border-bottom: transparent;
  }

  /deep/.van-radio__icon--checked .van-icon {
    background-color: #00d079;
    border-color: #00d079;
  }

  /deep/.van-collapse-item__content {
    padding: 0;
  }

  /deep/.van-dialog {
    overflow: scroll !important;
  }

  /deep/.el-dialog {
    border-radius: 10px;
  }

  /deep/.el-input__inner {
    padding: 0;
    border-radius: 0;
    border: 0;
    height: 24px;
    color: #323233;
  }

  /deep/.el-dialog__body {
    padding-top: 0.2rem;
    border-radius: 10px;
  }

  .text-wrapper_2 {
    .more {
      /* /deep/.van-cell__title {
        padding-left: 15px;
      } */

      /* padding-left: 0; */
    }
  }

  /deep/.el-dialog {
    margin: auto;
    margin-top: 0 !important;
    top: 50%;
    transform: translateY(-50%);
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;
  }

  /deep/.el-dialog__body {
    max-height: 420px;
    overflow: hidden;
    padding: 0;
  }

  /deep/.van-field--min-height .van-field__control {
    min-height: 0.6rem;
  }

  /deep/.van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #00d079;
    border-color: #00d079;
  }

  /deep/.van-calendar__selected-day {
    background-color: #00d079;
  }

  /deep/.van-button--danger {
    background-color: #00d079;
    border: 0.02667rem solid #00d079;
  }

  /deep/.van-radio--horizontal {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  /deep/.van-checkbox--horizontal {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  .moredialog {
    /deep/.van-field__value {
      width: 250px;
    }
  }



  .justify-between {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }

  .flex-row {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    flex-direction: row;
  }

  /deep/.van-radio--horizontal {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  /deep/.van-checkbox--horizontal {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  .group_28 {
    padding: 0 0 11px 0;
  }

  .nav-bar_2 {
    width: 411px;
    background: none;
    height: 44px;
  }

  .nav-bar_2 .van-nav-bar__content {
    height: 100%;
  }

  .nav-bar_2 .van-nav-bar__left {
    padding: 0 0 0 26px;
    align-items: start;
  }

  .label_1 {
    width: 26px;
    height: 26px;
    margin-top: 6px;
  }

  .nav-bar_2 .van-nav-bar__title {
    line-height: 22px;
  }

  .text_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    margin-top: 4px;
  }

  .box_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin: 0 5px 0 80px;
    padding: 16px 19px 16px 16px;
  }

  .titles {
    display: inline-block;
    width: 6px;
    height: 17px;
    line-height: 20px;
    background-color: #00d079;
    text-align: center;
  }

  .titles-1 {
    padding: 9px 0 9px 16px;
    /* margin-right: 16px; */
    line-height: 20px;
    border-radius: 3px;
    background-color: rgba(242, 247, 255, 1);
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    text-align: left;
    font-family: Arial;
  }

  .paragraph_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 26px;
  }

  .image-text_24 {
    width: 245px;
    margin: 16px 118px 0 0;
  }

  .icon_1 {
    width: 14px;
    height: 15px;
    margin: 2px 0 3px 0;
  }

  .text-group_1 {
    width: 223px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_2 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 5px 321px 0 15px;
  }

  .text_3 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .group-8 {
    padding: 16px;
  }

  .image-text_25 {
    width: 245px;
    margin: 16px 118px 0 0;
  }

  .icon_2 {
    width: 14px;
    height: 14px;
    margin: 0 0 2px 0;
  }

  .pagehotelcopy {
    width: 10px;
    height: 11px;
  }

  .text-group_2 {
    width: 223px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_4 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image-text_26 {
    width: 156px;
    margin: 16px 206px 0 1px;
  }



  .text-70 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 17px;
  }

  .button-6 {
    background-color: rgba(250, 173, 122, 0.14);
    border-radius: 28px;
    border: 1px solid #00d079;
    padding: 2px 7px 1px 7px;
  }

  .text-71 {
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .icon_3 {
    width: 12px;
    height: 16px;
    margin: 2px 0 2px 0;
  }

  .group_3 {
    margin-bottom: 35px;
  }

  .text-group_3 {
    width: 135px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_6 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_7 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .box_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0 0;
    position: relative;
    align-self: center;
    margin-top: -1px;
    margin: 0 8px 0 8px;
    padding: 16px 19px 0 16px;
  }

  .text_8 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text-wrapper_8 {
    width: 111px;
    margin-top: 46px;
  }

  .text_11 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_12 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text-wrapper_9 {
    width: 95px;
    margin: 25px 16px 0 0;
  }

  .text_13 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_14 {
    width: 100%;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_15 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 0px;
    background: none;
    border: 0;
    flex: auto;
  }

  .input_1 {
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    width: 398px;
    position: absolute;
    left: 0;
    top: 72px;
    padding-left: 141px;
    padding-right: 141px;
  }

  .input_1 .van-field__body {
    height: 50px;
  }

  .text_16 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 0px;
    background: none;
    border: 0;
    flex: auto;
  }

  .text_17 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .button-1 {
    background-color: #00d079;
    border-radius: 25px;
    margin: 30px 0 15px 17px;
    padding: 13px 0 13px 0;
  }

  .button-5 {
    background-color: #00d079;
    border-radius: 22px;
    padding: 6px 53px 6px 53px;
  }

  .button_1 {
    background-color: #00d079;
    border-radius: 25px;
    margin: 114px 0 0 0;
    width: 100%;
    padding: 13px auto;
  }

  .button-4 {
    width: 100%;
    background-color: #00d079;
    border-radius: 22px;
    padding: 6px 53px 6px 53px;
  }

  .input_2 {
    position: absolute;
    left: 0;
    top: 121px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 141px;
    padding-right: 141px;
  }

  .input_2 .van-field__body {
    height: 50px;
  }

  .text_18 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_20 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 30px;
    background: none;
    border: 0;
    flex: auto;
  }

  .text_19 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 0;
  }

  .input_3 {
    position: absolute;
    left: 0;
    top: 170px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 16px;
  }

  .input_3 .van-field__body {
    height: 50px;
  }

  .text_21 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 1px;
  }

  .text_23 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 46px;
    background: none;
    border: 0;
    flex: auto;
  }

  .text_22 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 0;
  }

  .input_4 {
    position: absolute;
    left: 0;
    top: 219px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 16px;
  }

  .input_4 .van-field__body {
    height: 50px;
  }

  .dropdown_1 {
    border-radius: 0px 0px 4px 4px;
    position: absolute;
    left: 0;
    top: 268px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding: 11px 9px 13px 15px;
  }

  .text_24 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_25 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_26 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 46px;
  }

  .thumbnail_1 {
    width: 16px;
    height: 16px;
    margin: 5px 0 3px 133px;
  }

  /* .image-wrapper_5 {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/254095396a3c4fc296bce50dbbf492be_mergeImage.png);
  height: 40px;
  width: 399px;
  position: absolute;
  left: 0;
  top: 36px;
  } */

  .image_3 {
    width: 399px;
    height: 40px;
  }

  /* .button_6 {
  height: 22px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng23e038c296c9865e8b684bbd593a3d03c6f09545a2a9015b5ce7a40ef148f916)
    100% no-repeat;
  background-size: 100% 100%;
  width: 85px;
  position: absolute;
  left: 297px;
  top: 160px;
  padding: 2px 6px 1px 6px;
 } */

  .text_79 {
    overflow-wrap: break-word;
    color: rgba(246, 109, 17, 0.51);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_29 {
    position: relative;
    padding-top: 10px;
    /* margin-top: 10px; */

  }

  .group_29a {
    position: relative;
    overflow: hidden;
    height: 100%;
    background-color: #f5f5f7;
  }

  .group_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0 0;
    padding: 16px 10px 14px 16px;
    text-align: center;

  }

  .group-2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 16px 14px 14px 16px;
  }

  .text-wrapper_10 {
    margin-right: 340px;
  }

  .text_27 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .block_8 {
    margin-top: 22px;
  }

  .text_28 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_29 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_30 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 46px;
  }

  .thumbnail_2 {
    width: 16px;
    height: 16px;
    margin: 3px 0 5px 147px;
  }

  .group_30 {
    margin-top: 16px;
  }

  .section_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 16px 0 36px 0;
  }

  .text_31 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 318px 0 16px;
  }

  .box_5 {
    background-color: rgba(230, 230, 232, 0.56);
    margin-top: 2px;
    padding: 9px 279px 9px 14px;
  }

  .text_32 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_33 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
  }

  .text-wrapper_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 36px;
    width: 398px;
    height: 50px;
    padding: 14px 179px 14px 16px;
  }

  .text_34 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_35 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
    padding-left: 2px;
  }

  .section_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    position: relative;
    margin-top: 14px;
    padding: 16px 0 35px 0;
  }

  .text_36 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 302px 0 60px;
  }

  .text_37 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .block_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-top: 11px;
    padding: 13px 10px 14px 16px;
  }

  .icon_5 {
    width: 16px;
    height: 16px;
    margin: auto 5px;
  }

  .text_38 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_39 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 27px;
  }

  .text_40 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 16px;
  }

  .thumbnail_3 {
    width: 16px;
    height: 16px;
    margin: 3px 0 4px 77px;
  }

  .block_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: absolute;
    left: 0;
    top: 98px;
    width: 398px;
    height: 50px;
    padding: 14px 10px 13px 16px;
  }

  .icon_6 {
    width: 16px;
    height: 16px;
    margin: 3px 5px 4px 0;
    color: rgba(248, 95, 37, 1);
  }

  .text_41 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 1px 0 0 10px;
  }

  .text_42 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_43 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 24px;
  }

  .thumbnail_4 {
    width: 16px;
    height: 16px;
    margin: 3px 0 4px 191px;
  }

  .text_44 {
    position: absolute;
    left: 42px;
    top: 15px;
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_45 {
    position: absolute;
    left: 57px;
    top: 14px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_46 {
    position: absolute;
    left: 139px;
    top: 16px;
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .group_5 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    height: 134px;
    margin-top: 112px;
    padding-top: 16px;
  }

  .block_9 {
    width: 330px;
    align-self: center;
  }

  .text_47 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .image-text_27 {
    margin: 3px 0 2px 0;
    display: flex;
    align-items: baseline;
  }

  .checkbox_1 {
    margin: -1.2000000476837158px 6px -0.20000004768371582px 0;
  }

  .text-group_4 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .block_5 {
    background-color: rgba(230, 230, 232, 0.56);
    width: 398px;
    margin-top: 11px;
    padding: 9px 16px 9px 14px;
  }

  .image-text_28 {
    width: 154px;
  }

  .thumbnail_5 {
    width: 16px;
    height: 16px;
    margin: 3px 0 3px 0;
  }

  .text-group_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_48 {
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    margin-top: 3px;
  }

  .block_6 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    margin-top: -1px;
    padding: 14px 0 14px 0;
  }

  .block_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;
    width: 100%;
    /* padding: 20px 0 5px 16px; */
  }

  .block_1 /deep/.van-cell__title,
  .van-field__label {
    width: 3rem !important;
  }



  .icon_7 {
    width: 16px;
    height: 14px;
    margin: 6px 0 2px 0;
  }

  .text-group_6 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);

    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_49 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_6 {
    width: 16px;
    height: 16px;
    margin: 3px 0 3px 62px;
  }

  .group_6 {
    background-color: rgba(255, 255, 255, 1);
    margin-top: 4px;
    padding: 14px 10px 14px 19px;
  }

  .image-text_30 {
    width: 85px;
  }

  .icon_8 {
    width: 14px;
    height: 13px;
    margin: 7px 0 2px 0;
  }

  .text-group_7 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_50 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_7 {
    width: 10px;
    height: 11px;
  }

  .group_7 {
    background-color: rgba(255, 255, 255, 1);
    padding: 14px 10px 14px 17px;
  }

  .image-text_31 {
    width: 87px;
  }

  .icon_9 {
    width: 16px;
    height: 12px;
    margin: 5px 0 5px 0;
  }

  .text-group_8 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_51 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_8 {
    width: 10px;
    height: 11px;
  }

  .group_8 {
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    width: 398px;
    margin-top: 1px;
  }

  .text_52 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    display: flex;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .thumbnail_9 {
    width: 16px;
    height: 16px;
    margin-bottom: 1px;
  }

  .button-2 {
    display: flex;
    height: 22px;
    /* background: url(../../../assets/images/back.png) 100% no-repeat; */
    background-size: 100% 100%;
    right: 88px;
    padding: 2px 8px 1px 8px;
    border: 1px solid #00d079;
    border-radius: 10px;
  }

  .text_53 {
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_9 {
    background-color: rgba(230, 230, 232, 0.56);
    padding: 9px 230px 9px 14px;
  }

  .image-text_32 {
    width: 154px;
  }

  .thumbnail_10 {
    width: 16px;
    height: 16px;
    margin: 3px 0 3px 0;
  }

  .text-group_9 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_10 {
    background-color: rgba(255, 255, 255, 1);
    margin-top: 49px;
    padding: 14px 10px 14px 18px;
  }

  .image-text_33 {
    width: 86px;
  }

  .icon_10 {
    width: 16px;
    height: 15px;
    margin: 5px 0 2px 0;
  }

  .text-group_10 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_54 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_11 {
    width: 10px;
    height: 11px;
  }

  .group_11 {
    background-color: rgba(255, 255, 255, 1);
    padding: 14px 10px 14px 18px;
  }

  .image-text_34 {
    width: 86px;
  }

  .icon_11 {
    width: 16px;
    height: 12px;
    margin: 6px 0 4px 0;
  }

  .text-group_11 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_55 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_12 {
    width: 10px;
    height: 11px;
  }

  .group_12 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 4px 4px;
    position: relative;
  }


  .text_56 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .thumbnail_13 {
    width: 16px;
    height: 16px;
    margin-bottom: 1px;
  }

  /* .button_3 {
  height: 22px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb7bc00fc956ca10018c0e2e7721c003a2db4c99fb128b8f68c1d1f28ce0e4e78)
    100% no-repeat;
  background-size: 100% 100%;
  width: 66px;
  position: absolute;
  left: 316px;
  top: 14px;
  padding: 2px 20px 1px 20px;
 } */

  .text_57 {
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_13 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-top: 16px;
    padding: 16px 0 8px 0;
  }

  .section_4 {
    width: 347px;
    margin: 14px 19px 0 8px;
  }

  .button_7 {
    width: 99px;
    height: 38px;
    border-radius: 19px;
    background-color: #00d079;
    color: rgba(206, 206, 206, 1);
    font-size: 14px;
    text-align: center;
    font-family: Microsoft Yahei;
    border: 1px solid rgba(187, 187, 187, 1);
  }

  .text_9 {
    width: auto;
    margin: auto;
    text-align: center;
  }

  .button_8 {
    width: 231px;
    height: 38px;
    border-radius: 19px;
    background-color: #00d079;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    text-align: center;
    font-family: Microsoft Yahei;
  }

  .text_58 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .checkbox_2 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: 1.7999999523162842px 0 1.7999999523162842px 242.79999995231628px;
  }

  .text_59 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    margin: 3px 0 0 4.799999952316284px;
  }

  .section_5 {
    width: 322px;
    margin: 10px 60px 0 16px;
  }

  .icon_12 {
    background-color: rgba(250, 173, 122, 1);
    border-radius: 8px;
    margin-top: 1px;
    padding: 2px 5px 2px 5px;
  }

  .text_60 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-family: JLinXin;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 12px;
  }

  .text_61 {
    overflow-wrap: break-word;
    color: rgba(250, 173, 122, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_16 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: relative;
    margin-top: 11px;
    padding: 8px 10px 8px 16px;
  }

  .image-text_35 {
    width: 192px;
    margin: 7px 0 7px 0;
  }

  .thumbnail_14 {
    width: 20px;
    height: 20px;
  }

  .text-group_12 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .icon_13 {
    width: 30px;
    height: 34px;
    margin-left: 55px;
  }

  .text_62 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 6px 0 0 26px;
  }

  .thumbnail_15 {
    width: 16px;
    height: 16px;
    margin: 9px 0 9px 46px;
  }

  .icon_14 {
    position: absolute;
    left: 352px;
    top: 8px;
    width: 30px;
    height: 33px;
  }

  .group_17 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-top: 59px;
    padding: 16px 0 16px 0;
  }

  .box_8 {
    width: 366px;
    align-self: center;
  }

  .text_63 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .image-text_36 {
    width: 58px;
    margin: 3px 0 2px 0;
  }

  /deep/.el-dialog {
    .box-1 {
      width: 98%;
      align-self: center;
      margin-top: 40px;
      display: flex;
      border-radius: 10px;
      justify-content: center;
      position: absolute;
      bottom: 0;
      background-color: #fff;
    }
  }

  /deep/.van-dialog__content {
    .box-1 {
      width: 98%;
      align-self: center;
      margin-top: 40px;
      display: flex;
      border-radius: 10px;
      justify-content: center;
      bottom: 0;
      background-color: #fff;
    }
  }

  .checkbox_3 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -1.2000000476837158px 0 -0.20000004768371582px 0;
  }

  .text-group_13 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_19 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    margin-top: 2px;
    padding: 14px 19px 14px 16px;
  }

  .text_64 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_65 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 6px;
  }

  .image-text_37 {
    width: 58px;
    margin: 3px 0 2px 158px;
  }

  .thumbnail_16 {
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }

  .text-group_14 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_38 {
    width: 46px;
    margin: 3px 0 2px 30px;
  }

  .thumbnail_17 {
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }

  .text-group_15 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .box_9 {
    margin: 9px 16px 0 31px;
  }

  .text_66 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image-text_39 {
    width: 46px;
    margin: 2px 0 1px 105px;
  }

  .box_6 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_16 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_40 {
    width: 46px;
    margin: 2px 0 1px 26px;
  }

  .checkbox_4 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_17 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_41 {
    width: 46px;
    margin: 2px 0 1px 26px;
  }

  .section_3 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_18 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .box_10 {
    width: 190px;
    margin: 15px 16px 0 192px;
  }

  .image-text_42 {
    width: 46px;
  }

  .block_7 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_19 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_43 {
    width: 46px;
  }

  .box_7 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_20 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_44 {
    width: 46px;
  }

  .group_22 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_21 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_23 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 16px 155px 16px 16px;
  }

  .box_11 {
    width: 227px;
  }

  .text-wrapper_5 {
    width: 108px;
    height: 28px;
    margin-bottom: 14px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_67 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_68 {
    height: 28px;
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_69 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text-wrapper_6 {
    width: 103px;
    height: 28px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_70 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_71 {
    height: 28px;
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_72 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text-wrapper_7 {
    width: 139px;
    height: 28px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
    margin: 14px 85px 0 3px;
  }

  .text_73 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_74 {
    height: 28px;
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .button_4 {
    background-color: #00d079;
    border-radius: 28px;
    align-self: center;
    margin-top: 16px;
    width: 320px;
    padding: 13px 127px 13px 127px;
  }

  .button_4[disabled] {
    color: #00d079;
    border: none;
    background-color: #c8c9cc;
  }

  .text_75 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_25 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 4px 4px;
    height: 83px;
    width: 398px;
    position: absolute;
    left: 8px;
    top: 425px;
    padding: 17px 48px 16px 30px;
  }

  .button_5 {
    border-radius: 28px;
    border: 1px solid #00d079;
    padding: 13px 119px 13px 111px;
  }

  .text_76 {
    overflow-wrap: break-word;
    color: #00d079;
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_26 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: absolute;
    left: 8px;
    top: 1196px;
    width: 398px;
    height: 50px;
    padding: 8px 10px 8px 16px;
  }

  .image-text_45 {
    width: 170px;
    margin: 6px 0 7px 0;
  }

  .thumbnail_18 {
    width: 20px;
    height: 20px;
    margin-bottom: 1px;
  }

  .text-group_22 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
  }

  .icon_15 {
    width: 30px;
    height: 34px;
    margin-left: 77px;
  }

  .text_77 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 6px 0 0 26px;
  }

  .thumbnail_19 {
    width: 16px;
    height: 16px;
    margin: 9px 0 9px 43px;
  }

  .icon_16 {
    position: absolute;
    left: 352px;
    top: 8px;
    width: 30px;
    height: 33px;
  }

  .group_27 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: absolute;
    left: 8px;
    top: 852px;
    width: 398px;
    height: 50px;
    padding: 14px 10px 14px 18px;
  }

  .image-text_46 {
    width: 86px;
  }

  .icon_17 {
    width: 16px;
    height: 14px;
    margin: 6px 0 2px 0;
  }

  .text-group_23 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_78 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }
</style>
<style scoped lang="less">
  .inputkuang {
    position: relative;
    background-color: #fff;
    padding: 0 20px 1px;
    border-radius: 0 0 4px 4px;
  }

  .inputkuang2 {
    background-color: #fff;
    padding: 0 20px 1px;
    border-radius: 0 0 4px 4px;
  }

  .inputkuang2 dl {
    margin-bottom: 15px;
  }

  .inputkuang2 dl dt {
    font-size: 0.42667rem;
    color: #000;
    position: relative;
    margin-bottom: 0.26667rem;
  }

  .inputkuang2 input,
  .inputkuang2 textarea {
    border: #dddddd solid 0.02667rem;
    border-radius: 0.13333rem;
    padding: 0.26667rem;
    width: 100%;
  }

  .inputkuang2 dl dd {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }

  .inputkuang2 dl dt sup {
    color: red;
    position: absolute;
    top: -0.02667rem;
  }

  sup {
    margin-left: 0.16rem;
  }

  .inputkuang2 /deep/.van-cell {
    padding: 10px 0;
  }

  .signup {
    position: absolute;
    height: 100%;
    width: 100%;
    background: #f3f3f3;
    padding: 55px 0;
  }

  /deep/ .van-cell__value {
    width: 100%;
  }

  /deep/ .van-icon {
    display: block !important;
  }

  /deep/.van-cell__right-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .intrCont {
    line-height: 24px;
  }

  .successBox {
    width: 100%;
    height: 350px;
    background: #fff;
    text-align: center;
    color: #4cb82f
  }



  .successBox i {
    font-size: 52px;
    margin-bottom: 20px;
    margin-top: 132px;
  }

  .buttonDiv {
    position: fixed;
    bottom: 0;
    left: 16px;
    width: 91%;
    padding: 10px 0;
    background-color: #fff;
    text-align: center;
    display: flex;
    justify-content: center;
    border-radius: 10px;
  }

  .invoicelist /deep/input {
    border: 0 !important;
    padding: 0;
  }

  .closeicon {
    width: 94%;
    height: 20px;
    position: fixed;
    padding: 3%;
    background-color: #fff;
    z-index: 100;
    display: flex;
    justify-content: space-between;
  }

  .closeicon .van-icon-cross {
    color: #c8c9cc;
    font-size: 14px;
  }

  .inputBox {
    z-index: 10 !important;
  }

  /deep/.van-dialog__footer {
    display: none;
  }

  /deep/.van-calendar__day--start,
  /deep/.van-calendar__day--end {
    background-color: #00d079;
  }

  /deep/.van-calendar__day--middle {
    color: #00d079;
  }

  /* .hotel /deep/.van-popup__close-icon--top-right {
    position: fixed;
    bottom: 50%;
    width: 94%;
    text-align: right;
    background-color: #fff;
    padding: 3%;
  } */
</style>